export default "__VITE_ASSET__55775f5a__"